
  export default {
    mounted() {
      this.shell = this.el.closest("[data-layout-portal-shell]");
      this.media = window.matchMedia("(width >= 1024px)");
      this.updateExclusion = () => {
        if (!this.shell) return;
        const size = this.media.matches ? 0 : this.el.getBoundingClientRect().height;
        // A patch resets the shell's attributes to the server's, which have no style;
        // LiveView reapplies attributes set through this.js() after every patch.
        this.js().setAttribute(this.shell, "style", `--layout-chrome-block-end: ${size}px`);
      };
      this.observer = new ResizeObserver(this.updateExclusion);
      this.observer.observe(this.el);
      this.media.addEventListener("change", this.updateExclusion);
      this.updateExclusion();
    },
    destroyed() {
      this.observer?.disconnect();
      this.media?.removeEventListener("change", this.updateExclusion);
      if (this.shell) this.js().removeAttribute(this.shell, "style");
    }
  }
